import React from "react";

import Button from "components/button/button";
import Link from "components/link/link";

import "./projectsNavigation.css";
import "./projectsNavigation-mobile.css";

class ProjectsNavigation extends React.Component {
  render() {
    const projects = this.props.projects.slice().reverse();
    return (
      <div className="projectsNavigationContainer">
        <div className="projectsNavigation">
          <div className="buttonForPadding">
            <Button color="green" to="/products">
              <p>Shop</p>
            </Button>
          </div>
          <div className="navigationItems">
            {projects.map(project => (
              <Link
                className="navigationItem"
                to={`/projects/${project.fields.slug}`}
                key={project.fields.slug}
              >
                <div className="button">
                  <p>{project.fields.title}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    );
  }
}
export default ProjectsNavigation;
